export const notifications = [
	{
		avatar: "",
		timestamp: "30m",
		type: "regular",
		from: "Shakil Ahmed",
		body: "added an meeting that might interest you.",
		unread: true,
	},
	{
		avatar: "",
		timestamp: "2h",
		type: "regular",
		from: "User 1",
		body: "invited you to join a meeting about AI seminar.",
		unread: false,
	},
	{
		avatar: "",
		timestamp: "1d",
		type: "regular",
		from: "User 2",
		body: "You have a new task. Please check it now",
		unread: false,
	},
	{
		avatar: "",
		timestamp: "1d",
		type: "reminder",
		from: "User 2",
		body: "invited you to join a meeting about Blockchain seminar.",
		unread: false,
	},
	{
		avatar: "",
		timestamp: "1d",
		type: "reminder",
		from: "User 2",
		body: "You have a new task. Please check it now.",
		unread: false,
	},
];
